// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Blog$BenfaerberBlog from "../lib/Blog.bs.js";
import * as Project$BenfaerberBlog from "../lib/Project.bs.js";
import * as ProjectItem$BenfaerberBlog from "../components/ProjectItem.bs.js";
import * as ReactRouterDom$BenfaerberBlog from "../wrappers/ReactRouterDom.bs.js";

function s(prim) {
  return prim;
}

function AboutMePage(props) {
  var match = React.useState(function () {
        return {
                recentArticles: [],
                recentProjects: []
              };
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          Promise.all([
                  Blog$BenfaerberBlog.Api.getRecentArticles(),
                  Project$BenfaerberBlog.Api.getProjects()
                ]).then(function (param) {
                var recentProjects = param[1];
                var recentArticles = param[0];
                return Promise.resolve(setState(function (param) {
                                return {
                                        recentArticles: recentArticles,
                                        recentProjects: recentProjects
                                      };
                              }));
              });
        }), []);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "main-headshot",
                                      alt: "Ben Faerber",
                                      src: "../images/ben.webp"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("a", {
                                              children: [
                                                JsxRuntime.jsx("i", {
                                                      className: "uil uil-github-alt"
                                                    }),
                                                " @benfaerber"
                                              ],
                                              className: "monospace black-link",
                                              href: "https://github.com/benfaerber",
                                              rel: "noreferrer",
                                              target: "_blank"
                                            }),
                                        JsxRuntime.jsx("span", {
                                              className: "spacer",
                                              style: {
                                                paddingLeft: "20px"
                                              }
                                            }),
                                        JsxRuntime.jsxs("a", {
                                              children: [
                                                JsxRuntime.jsx("i", {
                                                      className: "uil uil-linkedin-alt"
                                                    }),
                                                " @ben-faerber"
                                              ],
                                              className: "monospace black-link",
                                              href: "https://www.linkedin.com/in/ben-faerber/",
                                              rel: "noreferrer",
                                              target: "_blank"
                                            })
                                      ],
                                      className: "socials is-flex is-align-items-center is-justify-content-center"
                                    })
                              ],
                              className: "column is-one-third"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h2", {
                                      children: "Hi! I'm Ben Faerber."
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "\n            I made this site to show off some of my projects and share some interesting concepts I have learned.\n            I am very interested in functional programming (this site is written in Rescript, a compile to Javascript language based on OCaml's robust type system).\n            I'm also fluent in German — some of the articles here are written in it.\n          "
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "\n          I am very interested in how we can abstract complex concepts into easily digestible pieces.\n          How can we model real world data and should this data interact with the outside world?\n          How does syntax affect the way we think about programming? How do the tools we choose affect the way we think about solving problems?\n          How can we become better programmers? These are the questions I would like to look into.\n          "
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "\n          I've been programming every day since I was 8 years old — my first\n          \"real\" language was C# in 2014 with Unity3D. I started programming in 2010 with GameMaker and GML.\n          For the last 5 years I've been building production software professionally,\n          mostly server code (mainly Go, Rust, PHP and OCaml).\n          I love to create just for the sake of creation.\n          "
                                    })
                              ],
                              className: "column"
                            })
                      ],
                      className: "columns no-side-margin-mobile"
                    }),
                JsxRuntime.jsx("div", {
                      className: "divider"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h2", {
                              children: "Projects"
                            }),
                        JsxRuntime.jsx("div", {
                              className: "mb-2"
                            }),
                        JsxRuntime.jsx("div", {
                              children: Belt_Array.map(Belt_Array.slice(state.recentProjects, 0, 4), (function (project) {
                                      return JsxRuntime.jsx(ProjectItem$BenfaerberBlog.make, {
                                                  project: project,
                                                  size: "Small"
                                                }, "project-" + project.slug);
                                    })),
                              className: "is-flex is-flex-wrap-wrap"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ReactRouterDom$BenfaerberBlog.Link.make, {
                                    children: "See More...",
                                    href: "/projects",
                                    className: "monospace"
                                  })
                            })
                      ]
                    }),
                JsxRuntime.jsx("div", {
                      className: "divider"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h2", {
                              children: "What I've been working on"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h5", {
                                      children: "Professionally"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "\n          I own the shipping and fulfillment stack at True Leaf Market. The wholesale shipping software\n          (Laravel) rate-shops every major carrier and has moved $2.1M of goods in a single month.\n          A print server I wrote in Go drives a fleet of industrial Zebra printers unattended, speaking the\n          ZPL host protocol over raw TCP with backpressure and odometer checks so no label is skipped or\n          printed twice. Search runs on a Rust and Meilisearch microservice that serves a million requests\n          a day on $160 of hosting. Warehouse hardware like scanners and scales connects through a\n          standalone Rust application.\n        "
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("span", {
                              className: "px-1"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h5", {
                                      children: "Personally"
                                    }),
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        "I run ",
                                        JsxRuntime.jsx("a", {
                                              children: "Stripy Horse",
                                              href: "https://stripyhorse.io",
                                              rel: "noreferrer",
                                              target: "_blank"
                                            }),
                                        ", a developer platform for Zebra label printing written in Go. It grew out of my pdf-to-zpl\n          library and turned into the tooling I always wanted in the warehouse: ZPL previews that match the\n          printhead pixel for pixel, barcode grading, and virtual printers you can point real code at."
                                      ]
                                    }),
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        "My other big personal project is ",
                                        JsxRuntime.jsx("a", {
                                              children: "Cawtalker",
                                              href: "https://cawtalker.org",
                                              rel: "noreferrer",
                                              target: "_blank"
                                            }),
                                        " — building an AI to talk to the crows in my backyard."
                                      ]
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "\n            I write Go, Rust and PHP professionally and contribute to open source tools like yt-dlp\n            (I reverse engineered the Parti livestream platform for it) and Rector Laravel (an automated\n            refactoring tool). I attended Laracon and met some great people in the community.\n          "
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "\n          I like learning languages, I've spent the most time with German but I've studied Spanish and French as well.\n          I think there is a connection between programming and human language.\n          "
                                    })
                              ]
                            })
                      ]
                    }),
                JsxRuntime.jsx("div", {
                      className: "divider"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h2", {
                              children: "Articles"
                            }),
                        JsxRuntime.jsx("div", {
                              className: "mb-4"
                            }),
                        JsxRuntime.jsx("div", {
                              children: Belt_Array.map(state.recentArticles, (function (article) {
                                      var slug = article.slug;
                                      var description = article.description;
                                      return JsxRuntime.jsx(ReactRouterDom$BenfaerberBlog.Link.make, {
                                                  children: JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("h4", {
                                                                children: article.title
                                                              }),
                                                          description.length > 100 ? Js_string.slice(0, 100, description) + "..." : description,
                                                          JsxRuntime.jsx("div", {
                                                                className: "mb-3"
                                                              })
                                                        ]
                                                      }),
                                                  href: "/blog/" + slug,
                                                  className: "black-link"
                                                }, slug);
                                    })),
                              className: "about-me-article"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ReactRouterDom$BenfaerberBlog.Link.make, {
                                    children: "See More...",
                                    href: "/blog",
                                    className: "monospace"
                                  })
                            })
                      ]
                    })
              ]
            });
}

var $$String;

var make = AboutMePage;

export {
  $$String ,
  s ,
  make ,
}
/* react Not a pure module */
